import globalAxios from "../../../util/Api";
import { GET_OVERVIEW, START_LOADING, STOP_LOADING, ERROR } from "./types";
import { LogoutAction } from "../../../actions";

export const GetCustomerOverview = (yearField) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/reports/year_overview?year=${yearField}`)
      .then(({ data }) => {
        const binaryString = atob(data);
        const len = binaryString.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i += 1) {
          view[i] = binaryString.charCodeAt(i);
        }
        const blob = new File([view], { type: 'application/pdf' });
        const href = window.URL.createObjectURL(blob);
        if (data) {
          dispatch({ type: GET_OVERVIEW, payload: href })
        }

      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
export const GetYearOverview = (yearField) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/reports/year_overview_projects?year=${yearField}`)
      .then(({ data }) => {
        const binaryString = atob(data);
        const len = binaryString.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i += 1) {
          view[i] = binaryString.charCodeAt(i);
        }
        const blob = new File([view], { type: 'application/pdf' });
        const href = window.URL.createObjectURL(blob);
        if (data) {
          dispatch({ type: GET_OVERVIEW, payload: href })
        }

      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
export const GetYearConsultantOverview = (yearField) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/reports/year_overview_consultants?year=${yearField}`)
      .then(({ data }) => {
        const binaryString = atob(data);
        const len = binaryString.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i += 1) {
          view[i] = binaryString.charCodeAt(i);
        }
        const blob = new File([view], { type: 'application/pdf' });
        const href = window.URL.createObjectURL(blob);
        if (data) {
          dispatch({ type: GET_OVERVIEW, payload: href })
        }

      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}

export const GetYearStudentOverview = (yearField) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/reports/year_overview_students?year=${yearField}`)
      .then(({ data }) => {
        const binaryString = atob(data);
        const len = binaryString.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i += 1) {
          view[i] = binaryString.charCodeAt(i);
        }
        const blob = new File([view], { type: 'application/pdf' });
        const href = window.URL.createObjectURL(blob);
        if (data) {
          dispatch({ type: GET_OVERVIEW, payload: href })
        }

      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}

export const GetYearThemeOverview = (yearField) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/reports/year_overview_theme?year=${yearField}`)
      .then(({ data }) => {
        const binaryString = atob(data);
        const len = binaryString.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i += 1) {
          view[i] = binaryString.charCodeAt(i);
        }
        const blob = new File([view], { type: 'application/pdf' });
        const href = window.URL.createObjectURL(blob);
        if (data) {
          dispatch({ type: GET_OVERVIEW, payload: href })
        }

      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
export const GetYearLeadsOverview = (yearField) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/reports/year_overview_leads?year=${yearField}`)
      .then(({ data }) => {
        const binaryString = atob(data);
        const len = binaryString.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i += 1) {
          view[i] = binaryString.charCodeAt(i);
        }
        const blob = new File([view], { type: 'application/pdf' });
        const href = window.URL.createObjectURL(blob);
        if (data) {
          dispatch({ type: GET_OVERVIEW, payload: href })
        }

      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}

